export const authEndpoint = "https://accounts.spotify.com/authorize";

export const clientId = "2afcdb5ffe3a44f48d0491136211c8ce";
export const redirectUri = "https://hub-seven.vercel.app/";
export const scopes = [
  "user-top-read",
  "user-read-currently-playing",
  "user-read-playback-state",
];
